// Sick bay's beds in the browser (docs/sickbay.md): what the F menu offers while you lie in a sick bay bed with a medic there.
// Diagnosis and Heal me; once a diagnosis (or the CMO) finds an operation is needed, Surgery now and Refuse surgery. The server
// keeps the charts and decides everything (server/sickbay.ts); this is only the menu, so a pad has it on A like any other.
import type { SickbedView } from "../shared/sickbay.js";

export type BedAsk = "diagnose" | "heal" | "operate" | "refuse" | "call";
// no medic with you (they went back to their post, or none has come yet): call one to the bed
export function bedOptions(v: SickbedView | null, ask: (op: BedAsk) => void): { label: string; act: () => void }[] {
  if (!v || !v.medic) return [{ label: "Call a medic to your bed", act: () => ask("call") }];
  if (!v.here) return [];
  const out = [{ label: `Ask ${v.medic}: Diagnosis`, act: () => ask("diagnose") }, { label: `Ask ${v.medic}: Heal me`, act: () => ask("heal") }];
  const s = v.surgery;
  if (s) {
    out.push({ label: `Surgery now (${s.parts.join(", ")}${s.risk > 0 ? `, ${Math.round(s.risk * 100)}% risk` : ""})${s.ordered ? " · CMO's orders" : ""}`, act: () => ask("operate") });
    if (!s.refused && !s.ordered) out.push({ label: "Refuse surgery", act: () => ask("refuse") });
  }
  return out;
}
